import React from 'react';
import { Mail, Phone, MapPin, Clock } from 'lucide-react';
import { companyInfo } from '../data/mockData';

const Contact = () => {
  return (
    <div className="page">
      {/* Hero Section */}
      <section className="page-hero">
        <div className="container">
          <div className="page-hero-content">
            <h1 className="heading-1">Get In Touch</h1>
            <p className="body-large">
              Ready to discuss how our technology can benefit your business? We're here to help.
            </p>
          </div>
        </div>
      </section>

      {/* Contact Information */}
      <section className="section">
        <div className="container">
          <div className="contact-grid">
            {/* Contact Details */}
            <div className="contact-info-section">
              <h2 className="heading-2">Contact Information</h2>
              <p className="body-medium">
                Get in touch with our team to discuss energy optimization, IoT monitoring, or ESG services.
              </p>

              <div className="contact-details">
                <div className="contact-detail-item">
                  <div className="contact-icon">
                    <Mail size={24} />
                  </div>
                  <div>
                    <h3 className="heading-3">Email</h3>
                    <a href={`mailto:${companyInfo.email}`} className="contact-link">
                      {companyInfo.email}
                    </a>
                  </div>
                </div>

                <div className="contact-detail-item">
                  <div className="contact-icon">
                    <Phone size={24} />
                  </div>
                  <div>
                    <h3 className="heading-3">Phone</h3>
                    <a href={`tel:${companyInfo.phone}`} className="contact-link">
                      {companyInfo.phone}
                    </a>
                  </div>
                </div>

                <div className="contact-detail-item">
                  <div className="contact-icon">
                    <MapPin size={24} />
                  </div>
                  <div>
                    <h3 className="heading-3">Address</h3>
                    <p className="body-medium">{companyInfo.address}</p>
                  </div>
                </div>

                <div className="contact-detail-item">
                  <div className="contact-icon">
                    <Clock size={24} />
                  </div>
                  <div>
                    <h3 className="heading-3">Business Hours</h3>
                    <p className="body-medium">Monday - Friday: 9:00 AM - 5:00 PM GMT</p>
                  </div>
                </div>
              </div>
            </div>

            {/* Quick Links */}
            <div className="contact-links-section">
              <h2 className="heading-2">What can we help with?</h2>
              
              <div className="contact-topics">
                <div className="topic-item">
                  <h3 className="heading-3">OH4 Energy System</h3>
                  <p className="body-medium">
                    Technical consultations, ROI assessments, and installation planning for HVAC and chiller optimization.
                  </p>
                </div>

                <div className="topic-item">
                  <h3 className="heading-3">IoT Sensor Solutions</h3>
                  <p className="body-medium">
                    Custom sensor deployments, dashboard setup, and integration with existing systems.
                  </p>
                </div>

                <div className="topic-item">
                  <h3 className="heading-3">ESG Services</h3>
                  <p className="body-medium">
                    ESG assessments, carbon footprint analysis, compliance reporting, and improvement strategies.
                  </p>
                </div>

                <div className="topic-item">
                  <h3 className="heading-3">General Inquiries</h3>
                  <p className="body-medium">
                    Questions about our services, partnership opportunities, or any other business matters.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Map Note */}
      <section className="section bg-section">
        <div className="container">
          <div className="map-note">
            <MapPin size={32} />
            <div>
              <h3 className="heading-3">Located in Central London</h3>
              <p className="body-medium">
                Our office is in Covent Garden, easily accessible by public transport. We serve clients across the United Kingdom.
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Contact;
